import React, { useContext } from 'react';
import { Redirect, navigate } from '@reach/router';
import UserContext from '../../contexts/UserContext';
import Splasher from '../Splasher';

const PublicRoute = ({ component: Component, ...rest }) => {
  const { lastPath, loading, currentUser } = useContext(UserContext);
  console.log('INSIDE PUBLIC ROUTE: ', currentUser);

  if (loading) {
    return <Splasher />;
  } else if (currentUser && lastPath && lastPath.userId === currentUser.username) {
    return <Redirect to={lastPath.path} noThrow />;
  } else {
    return <>{currentUser ? <Redirect to="/" noThrow /> : <Component {...rest} />}</>;
  }
};

export default PublicRoute;
